export const ROBOYU_SENSITIVITY_LEVEL_DEFAULT = 5
export const ROBOYU_SENSITIVITY_LEVEL_MAX = 9
export const ROBOYU_SENSITIVITY_LEVEL_MIN = 1

export const ROBOYU_RETAKE_DAILY_LIMIT = 3
